<template>
    <b-container fluid>

          <PortalNavbar show="true"></PortalNavbar>
            <section class="organisation_structure_area row" style="margin-left:50px;">
<div class="container">
<!--<div class="tittle wow fadeInUp">
                <h2>Organisation structure</h2>
               
            </div>-->
<div class="row organisation_row">

                <div>
<div class="subtittle">
                        <h2 style="color:#ec5624;">ORGANISATION STRUCTURE</h2>
                    </div>
<br/>

<div class="col-md-12">
<div class="tree" style="margin-left:12%;">
 

 <ul>
      
<li><a href="#" style="color:red;background:#FFE6CC;"><p style="color:blue;">Dy.Comissioner of labour as</p><u style="text-decoration: underline black;">CHAIRMAN-SGB</u></a>
 
<ul>    
<li><a href="#" style="color:red;background:#FFE6CC;"><u style="text-decoration: underline black;">SECRETARY-SGB</u><p style="color:blue;">GLO/Section Officer</p><p style="color:blue;">Government of Maharashtra</p></a>
      

<ul>
          
<li><a style="color:black;background: #c8e4f8;">&nbsp;&nbsp;&nbsp;Personal&nbsp;&nbsp;<br/>Officer</a>
         
 <ul>
              
<li><a style="color:black;background: #80FF00;">Assistant<br/>&nbsp;&nbsp;Secretary&nbsp;&nbsp;</a>
<ul>             
<li><a style="color:black;background: #80FF00;">Senior<br/>&nbsp;&nbsp;Inspectors&nbsp;&nbsp;</a> 
<ul>           
 <li><a href="#" style="color:red;background:#FFD966;"><br/><u style="text-decoration: underline black;">INSPECTOR</u></a></li>
          
</ul></li>
 
</ul></li>
</ul></li>
         
<li><a style="color:black;background: #c8e4f8;">Account <br/>Department</a></li>
         
<li><a style="color:black;background: #c8e4f8;">Establishment<br/>Department</a></li>
          
<li><a style="color:black;background: #c8e4f8;">ESIC <br/>Department</a></li>
          
<li><a style="color:black;background: #c8e4f8;">Provident<br/>Fund Dept.</a></li>
         
<li><a style="color:black;background: #c8e4f8;">Allotment<br/>Dept.</a></li>
 
     
</ul></li>
</ul></li>  

</ul>

</div> 
</div><br/><br/>



<div style="margin-top:570px;">
<div class="subtittle">
                        <h3 id="ch" style="color:#ec5624;">1-CHAIRMAN</h3>
                    </div><br/><br/>
<ul>Without    prejudice to the power and functions of the Board, the Chairman shall be    generally responsible for satisfactory execution of this Scheme and shall have    powers to execute the decisions of the Board subject to its directions and    particular.</ul><br>

				         
 <div class="subtittle">
                        <h4 style="color:#ec5624;">Responsibilities & Duties:-</h4>
                    </div>

<ol style="margin-left:33px;">
<li>To ensure that the decisions of the Board in regard to the adjustment of the registers of Security Guards are carried out expeditiously.</li>
<li>To ensure that the sanctions for temporary registration of Security Guards are carried out without delay.</li>
<li>To supervise and control the working of this scheme.</li>

<li>To take suitable steps, if any irregularities are detected by him or brought to his notice.</li>
<li>To regulate the recruitment and entry into, and the discharge from the Scheme of registered Security Guards of the Board and the allotment of registered Security Guards of the Board in the Board pool to the registered principal employers.</li>
<li>To ensure that the provisions of this Scheme in regard to transfer and promotion of registered Security Guards of the Board are carried out.</li>
<li>To constitute medical boards when required.</li>
<li>To ensure that conditions laid down in this scheme for the registration of principal employers are complied with by them.</li>
<li>To ensure that all forms, registers, returns and documents, devised by the Board are properly maintained.</li>
<li>To take disciplinary action against registered Security Guards of the Board and registered principal employers in accordance with the provisions of this Scheme.</li>
<li>To deal with appeals from the registered Security Guards and registered principal employers under clauses 35 and 36.</li>
<li>Discharge all functions relating to disciplinary action against registered principal employers and registered Security Guards of the Board to the extend<br/> permitted under clause 32.</li>
<li>To take suitable steps to give or make available adequate physical training, security training and fire fighting training to the registered.</li>
</ol><br/><br/>

<div class="subtittle">
                        <h3 id="se" style="color:#ec5624;">2-SECRETARY</h3>
  </div><br/><br/>

<ol style="margin-left:33px;">
<li>Keeping, adjusting and maintaining the register of registered principal employers.</li>
<li>Keeping, adjusting and maintaining from time to time, such registers or records, as may be necessary of registered Security Guards of the Board and the Security Guards of employer agency registered with the Board including any registers or records of registered Security Guards of the Board and the Security Guards of employer agency registered with the Board who are temporarily not available for work and whose absence has been approved by the Board and where the circumstances require removing from any registers or records the name of any registered Security Guard of the Board either at his request or in accordance with this Scheme.</li>
<li>The employment and control of registered Security Guards of the Board, who are available for work, when they are not otherwise employed in accordance with this Scheme.</li>
<li>The groping or re-grouping of registered Security Guards of the Board in suitable Boards pool in accordance with the instructions received from the Board in such groups as may be determined by the Board.</li>
<li>The allotment of registered Security Guards of the Board in the Board pool who are available for work to registered principal employers and for this purpose the Secretary.</li>
<li> 	
(I). The collection of levy or any other contribution from the registered principal employers under this Scheme. 
(II). The collection from registered Security Guards of the Board of contribution to the provident fund, insurance fund or any other fund which may be constituted under the scheme. 
(III). The payment to each registered Security Guards of all earnings lawfully due to him from the registered principal employer and the payment to such Security Guards of all monies payable by the Board in accordance with the provisions of this Scheme.</li>
<li>Appointing, subject to budget provisions, such officers and servants, from time to time, as may be authorized by the Board or the chairman to appoint.</li>
<li>The keeping of proper accounts of the cost of operating this scheme and of all receipts and expenses under it and making and submitting to the Board an Annual Report and Audited Balance Sheet and profit and loss accounts statement.</li>
<li>Framing budget annually for submission to the Board on or before the 15th day of February each year.</li>
<li>Maintaining complete service records of all registered Security Guards and record sheet of all registered principal employers.</li>
<li>Authorizing the employment of unregistered Security Guards in case registered Security Guards are not available for work in the Board pool or in such other circumstances as the chairman may approve.</li>
<li>Such other function as may, from time to time, subject to the provisions of this scheme, be assigned to him by the Board or the Chairman.</li>
</ol><br/><br/>

<div class="subtittle">
                        <h3 id="is" style="color:#ec5624;">3-INSPECTORS</h3>
  </div><br/><br/>

 <div class="subtittle">
                        <h4 style="color:#ec5624;">Power of Inspectors:-</h4>
                    </div><br/><br/>

<ul>I. The Board may appoint such persons as it thinks fit to be Inspectors possessing the prescribed qualifications for the purposes of this Act or any Scheme and may define the limits of their jurisdiction.</ul>

<ol style="margin-left:33px;">
<li>Subject to any rules made by the State Government in this behalf, an Inspector may </li>
<li>Enter and search at all reasonable hours, with such assistants as he thinks fit, any premises or place, where Security Guards are employed or work is given out to Security Guards in any factory or establishment, for the purpose of examining the register, record of wages or notices required to be kept or exhibited under any scheme, and require the production thereof, for inspection.</li>
<li>Examine any person whom he finds in any such premises or place and who, he has reasonable cause to believe, is a Security Guard employed therein or a Security Guard to whom work is given out there in.</li>
<li>Require any person giving any work to Security Guard or to a group of Security Guards to give any information, which is in his power to give, in respect of the names and addresses of the persons to whom the work is given, and in respect of payments made, or to be made, for the said work.</li>
<li>Seize or take copies of such registers, records of wages or notices or portions thereof, as he may consider relevant, in respect of an offence under this Act or any Scheme, which he has reason to believe has been committed by an  employer or principal.</li>
</ol>

<ul>II. Exercise such other powers as may be prescribed.Provided that, no one shall be required under the provisions of this section to answer any question or make any statement tending to incriminate himself.</ul>

<ol style="margin-left:33px;">
<li>Every Inspector appointed under this Section shall be deemed to be a public servant within the meaning of Section 21 of the Indian Penal code, 1860 (XLV of 1860).</li>
</ol>

</div>
</div>
</div>
</div>
</section>

</b-container>
</template>
<script>
import PortalNavbar from "@/components/PortalNavbar";
export default {
components: { PortalNavbar}
}
</script>

<style scoped>


/* .organisation_structure_area { 
  background: #fefefe;

} */
.organisation_structure_area .organisation_row {
padding-top:70px;
padding-bottom:70px;
  
}
.organisation_structure_area .organisation_row ul  {
  font: 400 14px/26px "Open sans", sans-serif;
  color: #555555;
	   
}

.organisation_structure_area .organisation_row ol  {
  font: 400 14px/26px "Open sans", sans-serif;
  color: #555555;
	 padding-top: 28px;
  padding-bottom: 54px;
	  
}

.subtittle h2 {
  font: 700 36px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h2:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 120px;
  background: #222222;
  left: 0;
  bottom: -22px;
}

.subtittle h3 {
  font: 700 26px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h3:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 80px;
  background: #222222;
  left: 0;
  bottom: -22px;
}

.subtittle h4 {
  font: 700 20px "Open sans", sans-serif;
  color: #222222;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 20px;
}
.subtittle h4:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 80px;
  background: #222222;
  left: 0;
  bottom: -22px;
}


* {margin: 0; padding: 0;}



.tree ul {
    
padding-top: 20px; position: relative;
	
	
transition: all 0.5s;
	
-webkit-transition: all 0.5s;
	
-moz-transition: all 0.5s;

}



.tree li {
	
float: left; text-align: center;
	
list-style-type: none;
	
position: relative;
	
padding: 20px 5px 0 5px;
	
	
transition: all 0.5s;
	
-webkit-transition: all 0.5s;
	
-moz-transition: all 0.5s;

}



/*We will use ::before and ::after to draw the connectors*/


.tree li::before, .tree li::after{
	
content: '';
	
position: absolute; top: 0; right: 50%;
	
border-top: 2px solid #000000;
	
width: 50%; height: 20px;

}


.tree li::after{
	
right: auto; left: 50%;
	
border-left: 2px solid #000000;

}

/*We need to remove left-right connectors from elements without 
any siblings*/

.tree li:only-child::after, .tree li:only-child::before {
	
display: none;

}



/*Remove space from the top of single children*/

.tree li:only-child{ padding-top: 0;}



/*Remove left connector from first child and 
right connector from last child*/

.tree li:first-child::before, .tree li:last-child::after{
	
border: 0 none;

}


/*Adding back the vertical connector to the last nodes*/

.tree li:last-child::before{
	
border-right: 2px solid #000000;
	
border-radius: 0 5px 0 0;
	
-webkit-border-radius: 0 5px 0 0;
	
-moz-border-radius: 0 5px 0 0;

}


.tree li:first-child::after{
	
border-radius: 5px 0 0 0;
	
-webkit-border-radius: 5px 0 0 0;
	
-moz-border-radius: 5px 0 0 0;

}

/*Time to add downward connectors from parents*/

.tree ul ul::before{
	
content: '';
	
position: absolute; top: 0; left: 50%;
	
border-left: 2px solid #000000;
	
width: 0; height: 20px;

}



.tree li a{
	
border: 3px solid #000000;

padding: 5px 10px;
	
text-decoration: none;
	
color: #666;
	
font-family: arial, verdana, tahoma;
	
font-size: 18px;
	
display: inline-block;
border-color:black;
	

	
border-radius: 5px;
	
-webkit-border-radius: 5px;
	
-moz-border-radius: 5px;
	
	

transition: all 0.5s;
	
-webkit-transition: all 0.5s;
	
-moz-transition: all 0.5s;

}



/*Time for some hover effects*/

/*We will apply the hover effect the lineage of the element also*/

.tree li a:hover, .tree li a:hover+ li a {
	
background: #c8e4f8; color: #000; border: 3px solid #000000;

}


/*Connector styles on hover*/

.tree li a:hover+ul li::after, 

.tree li a:hover+ul li::before, 

.tree li a:hover+ul::before, 

.tree li a:hover+ul ul::before{

	border-color:  #000000;

}


</style>



// WEBPACK FOOTER //
// src/components/Portal/Organization.vue